import { AdPopupRuntime } from '@widgets/ad-popup-runtime';

import { StudentDashboardPage } from './StudentDashboardPage';

export function StudentHomeDashboardPage() {
  return (
    <>
      <AdPopupRuntime surface="home_dashboard" />
      <StudentDashboardPage />
    </>
  );
}
